<template>
  <el-dialog v-drag-dialog="visible" v-bind="$attrs" v-on="$listeners">
    <div v-if="$slots.title" slot="title" class="flex flex-align-center">
      <slot name="title"></slot>
    </div>
    <div style="max-height: 67vh; overflow-y: auto; overflow-x: hidden">
      <slot></slot>
    </div>
    <div v-if="$slots.footer" class="flex-center footer padding-top-10">
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {}
  }
</script>

<style lang="scss" scoped>
  .footer {
    border-top: 1px solid #ebeef5;
  }
</style>
